__turbopack_context__.v({
  "className": "notosanslao_bdd454e0-module__6NMKpG__className",
  "variable": "notosanslao_bdd454e0-module__6NMKpG__variable",
});
